import Navbar from 'components/Navbar'
import React from 'react'
import { Col, Row } from 'reactstrap'
import { CustomButton } from 'styles/global'
import { TrabalheConoscoWrapper } from './style'

const TrabalheConosco = () => {
  return (
    <>
      <TrabalheConoscoWrapper>
        <Navbar />
        <div className="w-100 d-flex justify-content-center align-items-center">
          <div className="container container-banner flex-column-reverse flex-lg-row">
            <div>
              <h1 className="title">
                Faça parte de uma empresa com propósito, história e crescimento
                sólido.
              </h1>
              <span className="subtitle">
                Na Riber, acreditamos que nosso maior valor está nas pessoas. É
                por isso que, há mais de 24 anos, construímos uma trajetória de
                sucesso com base no respeito, na valorização dos talentos e na
                confiança de quem escolhe crescer com a gente.
              </span>

              <div className="container-beneficios">
                <h2>Nossos beneficios</h2>
                <Row className="d-flex row-gap-20">
                  <Col sm={6} md={3}>
                    <div className="card-beneficio">
                      <img
                        src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/trabalhe_conosco_2.png"
                        width={50}
                      />
                      <label>Saúde</label>
                      <span>Plano de saúde e odontológico.</span>
                    </div>
                  </Col>
                  <Col sm={6} md={3}>
                    <div className="card-beneficio">
                      <img
                        src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/trabalhe_conosco_3.png"
                        width={50}
                      />
                      <label>Auxílios</label>
                      <span>
                        Ticket Refeição, alimentação, transporte e auxílio
                        creche.
                      </span>
                    </div>
                  </Col>
                  <Col sm={6} md={3}>
                    <div className="card-beneficio">
                      <img
                        src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/trabalhe_conosco_4.png"
                        width={50}
                      />
                      <label>Seguro Vida</label>
                      <span>Plano custeado pela empresa.</span>
                    </div>
                  </Col>
                  <Col sm={6} md={3}>
                    <div className="card-beneficio">
                      <img
                        src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/trabalhe_conosco_5.png"
                        width={50}
                      />
                      <label>Gympass</label>
                      <span>
                        Planos para acesso a diversas academias e estúdios
                      </span>
                    </div>
                  </Col>
                </Row>
                <div className="d-flex justify-content-center mt-5">
                  <CustomButton
                    className="btn-vagas"
                    background="var(--roxo-riber)"
                    maxWidth="300px"
                    width="100%"
                    height="56px"
                    fontSize="1.2rem"
                    borderRadius={20}
                    onClick={() =>
                      window.open(
                        'https://ribercred.vagas.solides.com.br/',
                        '_blank'
                      )
                    }
                  >
                    Nossas Vagas
                  </CustomButton>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <img
                src="https://imagens-site-riber.s3.sa-east-1.amazonaws.com/trabalhe_conosco_1.png"
                className="img-banner"
              />
            </div>
          </div>
        </div>
      </TrabalheConoscoWrapper>
    </>
  )
}

export default TrabalheConosco
